import { runWithRenderSlice } from "@otto-ec/global-resources/core";
import type { CustomElement } from "./utils";

export const extendElementWithRenderSliceInit = (Base: CustomElement): CustomElement =>
  class extends Base {
    wasConnected = false;

    connectedCallback(): Promise<void> | void {
      /*                                  */
      if (this.wasConnected) return;

      /*                              */

      /*                                                                */
      /*                                         */

      /*                                                     */
      return runWithRenderSlice(async () => {
        /*                             */
        if (this.isConnected === false) return;

        /*                                                                   */
        /*                                 */

        await super.connectedCallback();
        this.wasConnected = true;
      });
    }

    disconnectedCallback(): Promise<void> | void {
      /*                              */
      if (!this.wasConnected) return;

      return runWithRenderSlice(async () => {
        /*                                */
        if (this.isConnected === true) return;

        await super.disconnectedCallback();
        this.wasConnected = false;
      });
    }
  };
